import { render, staticRenderFns } from "./PatientUserImage.vue?vue&type=template&id=d74d3c64"
import script from "./PatientUserImage.vue?vue&type=script&lang=js"
export * from "./PatientUserImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports